import React, {useState, useEffect} from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { LOADING } from '../../../redux_store/actionTypes';
import { DRIVER_COMMISSION, RIDE_PAYMENT, TRANSFER, WALLET_REFUND, WALLET_TOPUP, WITHDRAWAL } from '../../../redux_store/asyncConfig';
import { clearTransState } from '../../../redux_store/transactions/transaction_slice';
import { getTransactions } from '../../../redux_store/transactions/transaction_thunk';
import LoadingModal from '../../templates/modals/LoadingModal';
import Tabs from '../../templates/Tabs'
import OtherTransactionTable from './OtherTransactionTable';
import TransferTable from './TransferTable';
import ExportDataButton from '../../templates/ExportDataButton';

const TransactionsPage = () => {
  const dispatch = useDispatch();
  const [tabSelected, setTabSelected] = useState('Wallet Withdrawals');
  const { status, transactions } = useSelector((state)=>state.transaction);

  useEffect(()=>{
    dispatch(clearTransState());
    dispatch(getTransactions(getFormattedStatus(tabSelected)));
    // eslint-disable-next-line
  }, []);

  const getFormattedStatus = (criteria) => {
    let status;
    if(criteria === 'Wallet Top-ups')
      status = WALLET_TOPUP      
    else if (criteria === 'refunds')
      status = WALLET_REFUND
    else if (criteria === 'Wallet Withdrawals')
      status = WITHDRAWAL
    else if (criteria === 'Driver Commissions Deduction')
      status = DRIVER_COMMISSION
    else if (criteria === 'Transfers')
      status = TRANSFER
    else if (criteria === 'ride-payments')
      status = RIDE_PAYMENT
    else if (criteria === 'All')
      status = 'all'
    return status;
  }

  const handleTabSelection = (e) => {
    const tab = e.target.innerText;
    dispatch(clearTransState());
    dispatch(getTransactions(getFormattedStatus(tab)));
    setTabSelected(tab);
  }

  return (
    <div>
      {status === LOADING && <LoadingModal message={'Loading data...'} />}
      <Tabs
        active={tabSelected}
        heading={['Wallet Withdrawals', 'Wallet Top-ups', 'Transfers','Driver Commissions Deduction']} 
        onTabSelect={handleTabSelection}
      />
      <br />
      <ExportDataButton data={transactions} filename='wayride-transactions' />
      {tabSelected === 'Transfers' ? 
        <TransferTable 
          transactions={transactions} 
        /> :
        <OtherTransactionTable 
          transactions={transactions} 
        />
      }
    </div>
  )
}

export default TransactionsPage